class AEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const week = ["日", "月", "火", "水", "木", "金", "土"];
    const today = new Date();
    // 月末だとずれる可能性があるため、1日固定で取得
    var showDate = new Date(today.getFullYear(), today.getMonth(), 1);
    
    // 初期表示
    $('.calendar').each(function() {
      showProcess(today, this);
    });

    // 前の月表示
    $('.prev').on('click', function() {
      showDate.setMonth(showDate.getMonth() - 1);
      showProcess(showDate);
    })
    
    // 次の月表示
    $('.next').on('click', function() {
      showDate.setMonth(showDate.getMonth() + 1);
      showProcess(showDate);
    })
    
    // カレンダー表示
    function showProcess(date) {
      var year = date.getFullYear();
      var month = date.getMonth();
      $('.js-year').html(year);
      $('.js-month').html(month + 1);
    
      var calendar = createProcess(year, month);
      $('.calendar').html(calendar);

      $('.js-calendar-date').on('click', function() {
        $('.js-calendar-date').removeClass('is-active');
        $(this).addClass('is-active');
        $('.js-date').text($(this).text());
        $('.js-date-text').css({'display': 'inline'});
        sort_ajax();
      })
    }
    
    // カレンダー作成
    function createProcess(year, month) {
      // 曜日
      var calendar = "<table><tr class='dayOfWeek'>";
      for (var i = 0; i < week.length; i++) {
        calendar += "<th>" + week[i] + "</th>";
      }
      calendar += "</tr>";
    
      var count = 0;
      var startDayOfWeek = new Date(year, month, 1).getDay();
      var endDate = new Date(year, month + 1, 0).getDate();
      var lastMonthEndDate = new Date(year, month, 0).getDate();
      var row = Math.ceil((startDayOfWeek + endDate) / week.length);
    
      // 1行ずつ設定
      for (var i = 0; i < row; i++) {
        calendar += "<tr>";
        // 1colum単位で設定
        for (var j = 0; j < week.length; j++) {
          if (i == 0 && j < startDayOfWeek) {
            // 1行目で1日まで先月の日付を設定
            calendar += "<td class='disabled'>" + (lastMonthEndDate - startDayOfWeek + j + 1) + "</td>";
          } else if (count >= endDate) {
            // 最終行で最終日以降、翌月の日付を設定
            count++;
            calendar += "<td class='disabled'>" + (count - endDate) + "</td>";
          } else {
            // 当月の日付を曜日に照らし合わせて設定
            count++;
            if(year == today.getFullYear()
               && month == (today.getMonth())
               && count == today.getDate()){
              calendar += "<td class='today js-calendar-date'>" + count + "</td>";
            } else {
              calendar += "<td class='js-calendar-date'>" + count + "</td>";
            }
          }
        }
        calendar += "</tr>";
      }
      return calendar;
    }

    // ----------------------------
    // SP カレンダーモーダル
    // ----------------------------

    $('.js-modal, .js-close').on('click', function() {
      $('.is-modal').toggleClass('is-active');
      $('body').toggleClass('no-scroll');
    })

    // ----------------------------
    // ajaxで日付ソート
    // ----------------------------

    // let add_post_target = $('.x__ajax-add-post-target');

    // let load_btn = $('.load_btn');
    // let all_posts = load_btn.data("all-posts"); //カスタム投稿の全件数
    // let this_posts_num = load_btn.data("this-posts-num");
    // let add_posts_num = load_btn.data("add-posts-num");

    // load_btn.on("click", function () {
    //   //読み込み中はボタン非表示
    //   load_btn.addClass('is__hidden');

    //   //ajax処理。data{}のactionに指定した関数を実行、完了後はdoneに入る
    //   $.ajax({
    //     type: 'POST',
    //     url: ajaxurl,
    //     data: {
    //       'action': 'load_post_list_ajax', //functions.phpで設定する関数名
    //       'all_posts': all_posts,
    //       'this_posts_num': this_posts_num,
    //       'add_posts_num': add_posts_num,
    //     },
    //   })
    //   .done(function (data) { //my_ajax_action関数で取得したデータがdataに入る
    //     console.log(data);
    //     add_post_target.append(data);
    //     setTimeout(function () {
    //       add_post_target.find('.x__add-post').removeClass('is__hidden');
    //     }, 100);
    //     //表示件数を増やす
    //     this_posts_num = this_posts_num + add_posts_num;
    //     load_btn.attr('data-this-posts-num', this_posts_num);

    //     //まだ全件表示されていない場合、ボタンを再度表示
    //     if (all_posts > this_posts_num) {
    //       load_btn.removeClass('is__hidden');
    //     }
    //   })
    //   .fail(function () {
    //     alert('エラーが発生しました');
    //   })
    // });

    $('.js-prevMonth, .js-nextMonth').on("click", function() {
      $('.js-ttl').css({'display': 'block'});
      $('.js-date-text').css({'display': 'none'});
      $('.js-date').text('');
      sort_ajax();
    })


		var searchParams = new URLSearchParams( window.location.search );
		var url = location.href;
		var searchParams = new URL(url).searchParams;

    if(searchParams.get("p-cat")) {
      $('.js-cat').val(searchParams.get("p-cat"));
    }

    $('.js-cat').on("change", function() {
      $('.js-ttl').css({'display': 'block'});
      sort_ajax();
    })

    function sort_ajax(el) {
      $('.js-postList').animate({
        opacity: 0
      }, 100 );;
      let year = $('.js-year').eq(0).text();
      let month = $('.js-month').eq(0).text();
      let date;
      let cat;

      date = $('.js-calendar-date.is-active') ? $('.js-date').eq(0).text() : undefined;

      cat = $('.js-cat').val() ? $('.js-cat').val() : undefined;

      //ajax処理。data{}のactionに指定した関数を実行、完了後はdoneに入る
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          'action': 'load_post_sort_ajax', //functions.phpで設定する関数名
          'year': year,
          'month': month,
          'date': date,
          'cat': cat,
        },
      })
      .done(function (data) { //my_ajax_action関数で取得したデータがdataに入る
        if(data.length <= 3) {
          data = '<p>条件に該当するイベントはありません。<br>別の条件で検索してください。</p>';
        }
        $('.js-postList').html(data);
        $('.js-postList').animate({
          opacity: 1
        }, 100 );;
      })
      .fail(function () {
        alert('エラーが発生しました');
      })
    }
  }
}
